export const truncateText = (inputText: string, maxLength: number): string => {
  if (inputText.length <= maxLength) {
    return inputText;
  }

  const truncatedText = inputText.slice(0, maxLength).replace(/\s+\S*$/, '');

  return truncatedText + '...'; // Add an ellipsis to indicate that the text has been truncated
};
